import React from "react";
import EAAlert from "../../shared/EAAlert";
import "./../purchasedAssorts.scss";
import "./style.scss";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { HiOutlineClock } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import { Exercise } from "../../../models/Exercise";
import useMethodAccount from "../hooks/useMethodAccount";
import useFacility from "../../../../utils/hooks/useFacility";

interface IProps {
  ticket: Ticket;
  exercise: Exercise;
  onRefreshTickets: () => void;
}

const PastReservation: React.FC<IProps> = ({ ticket, exercise, onRefreshTickets }) => {
  useMethodAccount();
  const facilityIds = useFacility();
  const showAllStatuses = facilityIds === "1243" || facilityIds === "1241";

  return (
    <div className="pastReservation">
      <div className="pastReservation__left">
        <b>{exercise.name}</b>

        <b>
          {" "}
          <HiOutlineClock /> {format(exercise.startTime, "dd.MM.yyyy")} r. |{" "}
          {format(utcToZonedTime(exercise.startTime, "Europe/Warsaw"), "HH:mm")}
        </b>

        {exercise.deputyHumanName ? <b>{exercise.deputyHumanName}</b> : <b>{exercise.humanName}</b>}
      </div>
      <div className="pastReservation__right">
        <b>{ticket.name}</b>
        <b>
          {showAllStatuses && exercise.status === "A" && <EAAlert type="warning" compact message={"Nieobecny"} />}
          {showAllStatuses && exercise.status === "U" && <EAAlert type="success" compact message={"Wykorzystany"} />}
          {!showAllStatuses && exercise.status === "A" && <EAAlert type="success" compact message={"Aktywny"} />}
        </b>
      </div>
    </div>
  );
};

export default PastReservation;
